import { render, staticRenderFns } from "./tbjm.vue?vue&type=template&id=69f1de07&scoped=true&"
import script from "./tbjm.vue?vue&type=script&lang=js&"
export * from "./tbjm.vue?vue&type=script&lang=js&"
import style0 from "./tbjm.vue?vue&type=style&index=0&id=69f1de07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f1de07",
  null
  
)

export default component.exports